// -----------------------------------------------------------------------------
// Scripts for multiple slider
// -----------------------------------------------------------------------------

$(function () {
  const multipleSlider = $('.multiple-slider');

  $.each(multipleSlider, function(index, value) {
    const mainSlider = $(this).find('.main-slider').attr('id');
    const mainSliderAutoplay = $(this).find('.main-slider').attr('data-main-slider-autoplay');
    const asideSlider = $(this).find('.aside-slider').attr('id');
    const asideSliderAutoplay = $(this).find('.aside-slider').attr('data-aside-slider-autoplay');

    $(`#${mainSlider}`).slick({
      autoplay: mainSliderAutoplay === '1' ? true : false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      fade: false,
      arrows: true,
      dots: false
    });

    $(`#${asideSlider}`).slick({
      autoplay: asideSliderAutoplay === '1' ? true : false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      fade: true,
      arrows: false,
      dots: true
    });
  });
});